module.exports = __webpack_public_path__ + "media/icons/negative_status-b733e6bf.png";